// Module
var code = "<ng-form> <kform-builder-option-key></kform-builder-option-key> <kform-builder-option property=\"kdata.submit\"></kform-builder-option> <kform-builder-option-path></kform-builder-option-path> </ng-form> ";
// Exports
export default code;